// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'                  // vuex
// import './assets/css/common.css'                          // 公共CSS
import './assets/iconfont/iconfont.css'                   // 字体图标
import beforeEach from './router/route-hook/beforeEach'   // 引入路由钩子跳转前公共函数
import afterEach from './router/route-hook/afterEach'     // 引入路由钩子跳转后公共函数
import $utils from '@assets/utils'                        // 公共自定义钩子函数
import * as $api from '@assets/api'                       // api请求函数
// import ElementUI from 'element-ui'
import './assets/element/'
import 'element-ui/lib/theme-chalk/index.css'
import 'bloom-model-ui/lib/bloomModelUi.css'
import './assets/css/less/common.less'
import locale from 'element-ui/lib/locale' // elementUI的国际化
import _ from 'lodash'
import htmlToPdf from './assets/utils/htmlToPdf'             // html转pdf

import VueI18n from 'vue-i18n'
import languagePack from './assets/i18n/langs'
import ElementUI from 'element-ui'
import BloomUI from 'bloom-model-ui'

Vue.prototype.$utils = $utils
Vue.prototype.$api = $api
Vue.prototype._ = _
Vue.use(ElementUI)
Vue.use(BloomUI)
Vue.use(VueI18n)
Vue.use(htmlToPdf)

const i18n = new VueI18n({
  locale: localStorage.getItem('judge:lang') === 'en' ? 'en' : 'zh',
  messages: languagePack
})
locale.i18n((key, value) => i18n.t(key, value)) // elementui多语言切换

router.beforeEach((to, from, next) => { // 跳转路由前公共钩子函数
  beforeEach(to, from, next)
})
router.afterEach((to, from, next) => {  // 跳转路由后公共钩子函数
  afterEach(to, from, next)
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  i18n,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js